import { gql, useMutation } from '@apollo/client'
import { useNavigate } from '@reach/router'
import { useNotification } from '@btime/react-messager'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertTag($input: TagInput) {
    upsertTag(input: $input) {
      id
      name
    }
  }
`

export const useSaveTag = (type, onSuccess, value) => {
  const notify = useNotification()
  const navigate = useNavigate()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Tags'], client: generalClient })

  const handleRequest = name => {
    const input = { name, type }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!onSuccess) onSuccess([...value, resp.data?.upsertTag])
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar!' })
      }
    })
  }

  return [handleRequest, state]
}
